import React from "react"
import { Div, Text } from "atomize"
import { theme } from "../settings/config"
import ContentPill from "../atoms/ContentPill"
import { getPtrLevel } from "../utils/func.utils"
import { playerStyleLabel } from "../utils/lessonContent.utils"
import {
	focusItems,
	isTechnicalSheetEmpty,
	normalizeTechnicalSheet,
} from "../utils/technicalSheet.utils"

const SubLabel = ({ children }) => (
	<Text textSize="caption" textWeight="600" textColor={theme.colors.text_light}>
		{children}
	</Text>
)

// La scheda tecnica, in cima all'allievo aperto, senza un titolo suo: il
// livello PTR con cosa vuol dire, il tipo di giocatore e le macroaree su
// cui si lavora (src/utils/technicalSheet.utils.js). Si scrive dal bottone
// "Scheda" in fondo all'allievo (PlayerActions); finché è vuota qui non
// c'è niente.
//
// I bordi cadono su quelli del nome e del blocco delle lezioni, un rem
// dentro la scheda bianca.
function TechnicalSheet({ playerData }) {
	if (isTechnicalSheetEmpty(playerData.technicalSheet)) return null

	const sheet = normalizeTechnicalSheet(playerData.technicalSheet)
	const level = getPtrLevel(sheet.ptrLevel)
	const items = focusItems(sheet)
	// le macroaree con una nota hanno un blocco loro; le altre stanno in fila
	const withNote = items.filter(item => item.note)
	const withoutNote = items.filter(item => !item.note)

	return (
		<Div
			p={{ x: "0.5rem", t: "0.25rem", b: "0.75rem" }}
			d="flex"
			flexDir="column"
			style={{ gap: "0.75rem" }}>
			{level && (
				<Div d="flex" align="flex-start" style={{ gap: "0.75rem" }}>
					<Div
						title={`Livello PTR ${level.label}`}
						minW="2.75rem"
						h="1.75rem"
						p={{ x: "0.5rem" }}
						rounded="14px"
						d="flex"
						align="center"
						justify="center"
						bg={theme.colors.gunmetal_fill}
						textColor={theme.colors.white}
						textWeight="bold"
						textSize="caption"
						style={{ flexShrink: 0 }}>
						{level.label}
					</Div>
					<Text textSize="caption" textColor={theme.colors.gunmetal}>
						{level.description}
					</Text>
				</Div>
			)}

			{sheet.playerStyle && (
				<Div d="flex" align="center" flexWrap="wrap" style={{ gap: "0.5rem" }}>
					<SubLabel>Tipo di giocatore:</SubLabel>
					<ContentPill kind="playerStyle">{playerStyleLabel(sheet.playerStyle)}</ContentPill>
				</Div>
			)}

			{items.length > 0 && (
				<Div d="flex" flexDir="column" style={{ gap: "0.4rem" }}>
					<SubLabel>Ci lavoriamo:</SubLabel>
					{withNote.map(item => (
						<Div
							key={item.id}
							p="0.6rem 0.75rem"
							bg={theme.colors.background}
							rounded="15px"
							d="flex"
							flexDir="column"
							align="flex-start"
							style={{ gap: "0.35rem" }}>
							<ContentPill kind={item.kind} detail={item.detail}>
								{item.label}
							</ContentPill>
							<Text textSize="caption" style={{ whiteSpace: "pre-line" }}>
								{item.note}
							</Text>
						</Div>
					))}
					{withoutNote.length > 0 && (
						<Div d="flex" flexWrap="wrap" style={{ gap: "0.375rem" }}>
							{withoutNote.map(item => (
								<ContentPill key={item.id} kind={item.kind} detail={item.detail}>
									{item.label}
								</ContentPill>
							))}
						</Div>
					)}
				</Div>
			)}
		</Div>
	)
}

export default TechnicalSheet
